module.exports = __webpack_public_path__ + "static/media/vector-deviation.e4e1e44c.png";